module.exports = __webpack_public_path__ + "img/mdf.f5eea688.png";